import s from '#components/disclaimers/disclaimer.module.scss';
import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Translate } from 'next-translate';
import { formatCommaSeparatedString } from '#utils/format-string';

function getDrmProtectedTooltipText(
  t: Translate,
  allowedRegions: string[],
  deniedRegions: string[]
): string {
  const hasAllowedRegions = allowedRegions?.length > 0;
  const regionCodes = hasAllowedRegions ? allowedRegions : deniedRegions;

  const translatedRegions = (regionCodes ?? []).map((regionCode) =>
    t(`region_${regionCode}`, null, { fallback: '-' })
  );

  const geoBlockingTooltipKey = hasAllowedRegions
    ? 'geoblockingTooltipAllowedRegion'
    : 'geoblockingTooltipDeniedRegion';

  return t(geoBlockingTooltipKey, {
    regions: formatCommaSeparatedString(translatedRegions),
  });
}

type props = {
  allowedRegions: string[];
  deniedRegions: string[];
};

const DrmProtectedDisclaimer = ({ allowedRegions, deniedRegions }: props) => {
  const { t } = useTranslation();

  const tooltipText = getDrmProtectedTooltipText(
    t,
    allowedRegions,
    deniedRegions
  );

  return (
    <button className={s.host} title={t('infoButton')}>
      <span
        className={s.inner}
        dangerouslySetInnerHTML={{ __html: tooltipText }}
        role="presentation"
      />
    </button>
  );
};

export default DrmProtectedDisclaimer;
